import { Component, inject, Injector } from '@angular/core';
import { CommandsService, ICommandTemplateCreateModel } from "../../../../services/commands.service";
import { CommandDialogBaseComponent } from "../command-dialog-base/command-dialog-base.component";

@Component({
    selector: 'app-create-command',
    templateUrl: '../command-dialog-base/command-dialog-base.component.html',
    styleUrls: ['../command-dialog-base/command-dialog-base.component.css'],
    standalone: false
})
export class CreateCommandComponent extends CommandDialogBaseComponent<ICommandTemplateCreateModel> {
  private service: CommandsService = inject(CommandsService);

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createCommand";
  }

  public submit() {
    this.service.create(this.model)
      .subscribe((res) => {
        this.onCreated.emit();
        this.close();
        this.syncService.NotifyEntityChanged("Command", 0);
        super.submit();
      });
  }

}
